import { gql } from '@apollo/client';

export const KEY_LINK_OPTIONS_QUERY = gql`
  query GetKeyLinkOptions {
    orgLogo
    vm {
      forms {
        formId
        title
      }
      funnels {
        funnelId
        name
        slug
        description
        image
        isActive
      }
    }
  }
`;
